import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { Params, RouterModule } from '@angular/router';
import { TranslocoModule, provideTranslocoScope } from '@jsverse/transloco';
import { type ProfileType, VerticalType } from '@rma/common-ui-domain/types';
import { PossessivePipe } from '@rma/generic/util/pipes/possesive';
import { MapMarkerType, MapRequest } from '@rma/maps/domain';
import { MapCtaComponent } from '@rma/maps/public/orc-map-cta';

@Component({
  selector: 'rma-profile-map-cta',
  imports: [MapCtaComponent, MatButtonModule, PossessivePipe, RouterModule, TranslocoModule],
  providers: [provideTranslocoScope('profileMapCta')],
  templateUrl: './profile-map-cta.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProfileMapCTAComponent implements OnChanges {
  @Input()
  public name!: string;

  @Input()
  public canHaveProperties!: boolean;

  @Input({ required: true })
  verticalType!: VerticalType;

  @Input({ required: true })
  profileType!: ProfileType;

  @Input({ required: true })
  profileCode!: string;

  @Input()
  mapType: MapMarkerType = 'Review';

  @Input()
  mapUrl = '../map';

  @Input()
  mapUrlParams: Params | null | undefined = null;

  @Input()
  target: '_self' | '_blank' = '_self';

  @Input()
  useHref = false;

  @Input()
  skipCache = false;

  protected mapRequest: Partial<MapRequest> = {};

  ngOnChanges(changes: SimpleChanges): void {
    const { profileType, profileCode } = changes;

    if (profileType || profileCode) {
      this.mapRequest = {
        profileType: this.profileType,
        profileCode: this.profileCode,
        from: new Date(2014, 1, 1),
      };
    }
  }
}
